import { Link } from 'react-router-dom';
import type { Voisins } from '../parcours';

/**
 * Passage au candidat précédent ou suivant sans repasser par la liste
 * (demande du 2026-09-19). L'ordre est celui de la liste d'où l'on vient,
 * filtres et tri compris (`src/parcours.ts`). Le rang dit où l'on en est :
 * dépouiller vingt dossiers sans se perdre.
 *
 * Une flèche sans destination reste affichée mais désactivée : la place des
 * boutons ne bouge pas d'une fiche à l'autre, et le premier comme le dernier
 * dossier se voient tout de suite.
 */
export function FlechesParcours({ voisins }: { voisins: Voisins | null }) {
  if (!voisins) return null;
  const { precedent, suivant, rang, total, libelle } = voisins;

  return (
    <nav className="fleches-parcours" aria-label="Parcours des candidats">
      <Fleche
        vers={precedent}
        sens="précédent"
        libelle={libelle}
        signe="‹"
      />
      <span className="rang" aria-label={`Candidat ${rang} sur ${total}`}>
        {rang} / {total}
      </span>
      <Fleche vers={suivant} sens="suivant" libelle={libelle} signe="›" />
    </nav>
  );
}

function Fleche({
  vers,
  sens,
  libelle,
  signe,
}: {
  vers: string | null;
  sens: 'précédent' | 'suivant';
  libelle: string;
  signe: string;
}) {
  const description = libelle ? `Candidat ${sens} dans « ${libelle} »` : `Candidat ${sens}`;
  if (!vers) {
    return (
      <span className="fleche desactivee" aria-hidden="true">
        {signe}
      </span>
    );
  }
  return (
    <Link className="fleche" to={`/candidatures/${vers}`} aria-label={description} title={description}>
      <span aria-hidden="true">{signe}</span>
    </Link>
  );
}
